import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Admin from './views/Admin.vue'
import Login from './views/Login.vue'
import AdminCapsules from '@/components/AdminCapsules'
import AdminDashboard from '@/components/AdminDashboard'
import FormCreation from '@/components/FormCreation'
import store from './store/index'

import _ from 'underscore'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'is-active',
  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 250)
    })
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/library',
      name: 'library',
      component: () => import('@/views/Library')
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/capsule/:projectId',
      name: 'capsule',
      component: () => import('@/views/Project'),
      props: true
    },
    {
      path: '/collection/:collectionId',
      name: 'collection',
      component: () => import('@/views/Collection'),
      props: true
    },
    {
      path: '/capsule/:language/:reference', // :language/:url-reference
      component: () => import('@/views/Project'),
      props: true
    },
    {
      path: '/dashboard',
      component: Admin,
      meta: { requiresAuth: true, adminAuth: true },
      children: [
        { path: '', component: AdminDashboard },
        {
          path: 'pages',
          component: () => import('@/components/AdminPages'),
          children: [
            // { path: '', component: PagesSections },
            {
              path: ':pageName',
              name: 'pageManagement',
              component: () => import('@/components/AdminPageManagement'),
              props: true
            },
            {
              path: ':pageName/:sectionName/add',
              name: 'addSection',
              component: () => import('@/components/AdminPage'),
              props: true
            },
            {
              path: ':pageName/:sectionName/edit/:id',
              name: 'editSection',
              component: () => import('@/components/AdminPage'),
              props: true
            },
            {
              path: ':pageName/:elementName/add',
              name: 'addSectionElement',
              component: () => import('@/components/AdminForm'),
              props: true
            }
          ]
        },
        {
          path: 'capsules',
          component: AdminCapsules
        },
        {
          path: 'collections',
          component: () => import('@/components/AdminCollections')
        },
        {
          path: 'partners',
          component: () => import('@/components/AdminPartners')
        },
        {
          path: 'capsules/edition',
          name: 'capsuleEdition',
          component: () => import('@/components/AdminModalCreation'),
          props: true
        },
        {
          path: 'capsules/new',
          component: () => import('@/components/AdminModalCreation')
        },
        {
          name: 'editCapsule',
          path: 'capsules/edit/:id',
          component: FormCreation
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (_.contains(store.state.availableLanguages, to.query.lang)) {
    if (to.query.lang !== store.getters.activeLanguage) {
      store.commit('changeActiveLanguage', to.query.lang)
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.isLoggedIn) {
      next({ path: '/' })
      // query: { redirect: to.fullPath }
    } else {
      /* else if (to.matched.some(record => record.meta.adminAuth)) {
      if (!_.contains(store.getters.userRoles, 'administrators')) {
        next({
          path: '/'
        })
      } else {
        next()
      }
    } */
      next()
    }
  } else {
    if (from.query.lang && !to.query.lang) {
      next({
        path: to.path,
        query: { lang: from.query.lang }
      })
    }

    next() // make sure to always call next()!
  }
})

export default router
